import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  type: "button",
  class: "h-[36px] w-full text-light-gary-text-color border-light-gary-text-color border-[1px] bg-white font-normal rounded-lg text-xs"
}
const _hoisted_2 = { class: "m-auto h-full inline-flex text-center items-center tracking-[.12em]" }
const _hoisted_3 = { class: "px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Icon, {
        width: '16px',
        iconName: _ctx.iconName
      }, null, 8, ["iconName"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.text), 1)
    ])
  ]))
}